// extracted by mini-css-extract-plugin
export default {"controlContainer":"AmountInput_controlContainer__8DiBG","valueContainer":"AmountInput_valueContainer__oa7fV","inputContainer":"AmountInput_inputContainer__XIOr0"};